<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="申报表编号">
                                <a-input v-model="queryParams.cgsbbbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="申报年份">
                                <FGDictSelectCN dictNo="P0002" v-model="queryParams.sbnf" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="申报日期从">
                                <a-date-picker v-model="queryParams.sbrq1" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-date-picker v-model="queryParams.sbrq2" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert" v-if="xzIsVisible">新增</a-button>
                        <a-radio-group
                            button-style="solid"
                            v-model="queryParams.seltype"
                            :default-value="queryParams.seltype"
                            @change="loadData"
                            style="float:right;margin-right:10px "
                        >
                            <a-radio-button :value="0">全部</a-radio-button>
                            <a-radio-button :value="1">未提交</a-radio-button>
                            <a-radio-button :value="2">已提交</a-radio-button>
                        </a-radio-group>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="cgsbbbh" title="申报表编号" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="sbnf" title="申报年份" width="90" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="sbrq" title="申报日期" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="sbdwbh" title="申报单位编号" width="150" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="dwlb" title="单位类别" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="lxr" title="联系人1" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="lxdh" title="联系电话1" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="lrrxm" title="录入人" min-width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="lrrq" title="录入日期" width="120" sortable align="center">
                        <template v-slot="{ row }">
                            <span> {{ $FG_util.formatDate(row.lrrq, "YYYY-MM-DD") }} </span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="操作" width="160" align="center">
                        <template v-slot="scope">
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="onDelete(scope.row)"
                                >删除</span
                            >
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="edit(scope.row)"
                                >编辑</span
                            >
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "CgsbwhBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { seltype: 1 },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "cgsbbbh",
                order: "desc"
            },
            tableDataLoading: false,
            xzIsVisible: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        viewIsVisible: {
            get() {
                return this.showView;
            },
            set(newVal) {
                this.$emit("update:showView", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
        //获取当前时间
        this.getDateTimes();
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) === 2) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            } else {
                return 2;
            }
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listWTJ",
                    {
                        funid: "CG1001",
                        menuid: "E323869F-0DEC-4A36-94C0-BDEEA6DA7A22",
                        defaulttablename: "CG_CGSBB",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = { seltype: 1 };
        },
        //删除
        onDelete(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zxcggl/cgsbgl/delete", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                this.loadData(row.id);
                            }
                        });
                }
            });
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.viewIsVisible = true;
        },
        insert(row) {
            //查询该单位是否已经申报，是则不允许重复新增
            let year = this.$FG_util.formatDate(new Date(), "YYYY") - 1;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/selectIfExistCgsb",
                    {
                        sbdwid: this.getUserInfo.companyInfo.id,
                        sbnf: year
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success && data.data) {
                        if (data.data.length <= 0) {
                            // 设置编辑记录id
                            this.editDataId = null;
                            // 显示编辑界面
                            this.editIsVisible = true;
                        } else {
                            this.$FG_message.error("同一单位在同一年度只允许申报一次，您已申请过，请检查！");
                            return;
                        }
                    }
                });
        },
        //获取当前时间（具体时分秒）,从而控制新增按钮是否显示
        getDateTimes() {
            // let currentDate = this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:MM:SS");
            /*if (currentDate >= "2023-02-10 19:00:00" && currentDate <= "2023-02-14 19:30:59") {
                this.xzIsVisible = true;
            } else {
                this.xzIsVisible = false;
            }*/
            this.xzIsVisible = true;
        }
    }
};
</script>
